/**
 * @file     PathToOwningLink.tsx
 * @purpose  A link out of "What owning nearby costs" that reports
 *           path_to_owning_click with its target. The one client island in an
 *           otherwise server-rendered section.
 */
'use client';

import type { ReactNode } from 'react';
import Link from 'next/link';
import Box from '@mui/material/Box';
import type { SxProps, Theme } from '@mui/material/styles';
import { useListingEvents } from '@/hooks/useListingEvents';
import type { ListingEventProps } from '@/core/analytics/listingEvents';

type Target = ListingEventProps['path_to_owning_click']['target'];

interface Props {
  href: string;
  target: Target;
  listingKey: string;
  source: 'mls' | 'owner';
  children: ReactNode;
  sx?: SxProps<Theme>;
}

export function PathToOwningLink({ href, target, listingKey, source, children, sx }: Props) {
  const track = useListingEvents();
  return (
    <Box
      component={Link}
      href={href}
      onClick={() => track('path_to_owning_click', { listing_key: listingKey, target, listing_type: 'lease', listing_source: source })}
      sx={sx}
    >
      {children}
    </Box>
  );
}
